<template>
  <div class="container">
    <img :src="m100Left" alt="left-bg" class="left-bg" />
    <img :src="m100Right" alt="right-bg" class="right-bg" />
    <img :src="m100" alt="m100" class="m100 reveal-bottom" />
    <div class="wrap">
      <h3 class="title reveal-bottom">{{ $t("m100.t") }}</h3>
      <div>
        <div class="text reveal-bottom">
          {{ $t("m100.c1") }}
        </div>
        <div class="text reveal-bottom">
          {{ $t("m100.c2") }}
        </div>
        <div class="text reveal-bottom">
          {{ $t("m100.c3") }}
        </div>
      </div>
      <div class="download reveal-bottom">
        <div class="item">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/ios.svg')"
            alt="svg"
          />
          <p class="item-title">IOS</p>
          <div class="item-text">
            {{ $t("m100.c4") }}
          </div>
        </div>

        <!-- <div class="item" v-if="android">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/android.svg')"
            alt="svg"
          />
          <p class="item-title">Android</p>
          <a :href="android.url" class="android-click">
            <img
              class="qrcode"
              :src="
                android.qrCode ? 'data:image/png;base64,' + android.qrCode : ''
              "
              alt="qrCode"
            />
            <p>{{ $t("m100.c6") }}</p>
          </a>
        </div> -->

        <div class="item" v-if="mac">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/android.svg')"
            alt="svg"
          />
          <p class="item-title">Android</p>
          <a
            class="item-download"
            :href="android.url"
            :dwonload="android.name"
            >{{ $t("m100.c6") }}</a
          >
        </div>

        <div class="item" v-if="mac">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/mac.svg')"
            alt="svg"
          />
          <p class="item-title">Mac</p>
          <a class="item-download" :href="macSSL.url" :dwonload="macSSL.name">{{
            $t("m100.c5")
          }}</a>
          <a class="item-note" :href="mac.url" :dwonload="mac.name">{{
            $t("m100.ipsec_download")
          }}</a>
        </div>

        <div class="item" v-if="windows">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/window.svg')"
            alt="svg"
          />
          <p class="item-title">Windows</p>
          <a
            class="item-download"
            :href="windowsSSL.url"
            :dwonload="windowsSSL.name"
            >{{ $t("m100.c5") }}</a
          >
          <a class="item-note" :href="windows.url" :dwonload="windows.name">{{
            $t("m100.ipsec_download")
          }}</a>
        </div>
        <div class="item" v-if="windows">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/deb.png')"
            alt="svg"
          />
          <p class="item-title">{{ $t("m100.kylin_uos") }}</p>
          <a
            class="double-item-download"
            :href="debArm64.url"
            :dwonload="debArm64.name"
            >Arm64</a
          >
          <a
            class="double-item-download"
            :href="debx64.url"
            :dwonload="debx64.name"
            >x64</a
          >
        </div>
      </div>
    </div>
    <div class="wrap">
      <h3 class="title reveal-bottom">{{ $t("m100.t1") }}</h3>
      <div>
        <div class="text reveal-bottom">
          {{ $t("m100.c7") }}
        </div>
      </div>
      <div class="download reveal-bottom">
        <div class="item" v-if="netToolWindows">
          <img
            class="item-icon"
            :src="require('@/assets/img_svg/window.svg')"
            alt="svg"
          />
          <p class="item-title">Windows</p>
          <a
            class="item-download"
            :href="netToolWindows.url"
            :dwonload="netToolWindows.name"
            >{{ $t("m100.c5") }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/http";
import initAnimation from "../animation";
export default {
  data() {
    return {
      m100: require("@/assets/images/m100_o.png"),
      m100Left: require("@/assets/images/m100-left.png"),
      m100Right: require("@/assets/images/m100-right.png"),
      android: null,

      mac: null,
      macSSL: null,

      windows: null,
      windowsSSL: null,

      deb: null,

      netToolWindows: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    setTimeout(initAnimation, 0);
  },
  methods: {
    getData: async function () {
      const res = await axios.get("/api2/client/side/latest");

      if (res.code === 0) {
        this.android = res.data.ANDROID;
        this.mac = res.data.MAC;
        this.macSSL = res.data.MAC_SSL;
        this.windows = res.data.WIN;
        this.windowsSSL = res.data.WIN_SSL;
        this.debArm64 = res.data.LINUX_ARM64;
        this.debx64 = res.data.LINUX_ARM64;
        this.netToolWindows = res.data.NET_TOOL;
      }
      console.log(res);
    },
  },
};
</script>
<style scoped>
.container {
  position: relative;
}
.left-bg {
  display: block;
  position: absolute;
  left: 0;
  width: auto;
  height: 560px;
  top: 200px;
}
.right-bg {
  position: absolute;
  right: 0;
  top: 800px;
  height: 400px;
}
.m100 {
  display: block;
  width: 977px;
  /* height: 792px; */
  margin: 200px auto 0;
}
.wrap {
  width: 860px;
  margin: 66px auto 200px;
}
.title {
  font-size: 28px;
  color: #000000;
  letter-spacing: 0;
  font-weight: bold;
  line-height: 42px;
  margin-bottom: 28px;
}
.text {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
  letter-spacing: 0;
  line-height: 36px;
}
.download {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 60px;
}
.item {
  width: 200px;
  height: 275px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  margin-top: 18px;
}
.item-icon {
  width: 80px;
  height: 80px;
  margin: 37px auto 12px;
  display: block;
}
.item-title {
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
  line-height: 24px;
}
.item-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  padding: 0 24px;
  text-align: center;
  line-height: 20px;
  margin-top: 47px;
}
.qrcode {
  width: 77px;
  height: 77px;
  display: block;
  margin: 0 auto 0;
}
.item-download {
  display: block;
  width: 118px;
  height: 35px;
  margin: 50px auto 0;
  background: #00a3d1;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
  line-height: 35px;
  cursor: pointer;
}
.double-item-download {
  display: block;
  width: 118px;
  height: 35px;
  margin: 16px auto 0;
  background: #00a3d1;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
  line-height: 35px;
  cursor: pointer;
}
.android-click {
  display: block;
  width: 96px;
  margin: 20px auto 0;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  color: #000;
}
.android-click:hover > p {
  text-decoration: underline;
}
.item-note {
  display: block;
  text-align: center;
  color: #00a3d1;
  margin-top: 12px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/Pages/M100/M100.vue